
import { useEffect } from "react";
import { trackGA4Event } from "@/lib/analytics";

export default function DocsPageTracker({ slug }: { slug: string }) {
  useEffect(() => {
    trackGA4Event("select_content", {
      content_type: "documentation",
      item_id: slug,
    });
  }, [slug]);

  return null;
}
